import Hero from '../../components/Hero'
import './AgedCareHealthcare.css'

const AgedCareHealthcare = () => {
  return (
    <>
      <Hero 
        title="Aged Care & Healthcare"
        subtitle="Caring, hygienic cleaning for residents and patients."
        backgroundImage="/sectors/healthcare/healthcare.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Sector Overview</h2>
        </div>
        <p>Health and aged care facilities require meticulous cleaning standards to protect vulnerable residents and patients. Our specialised teams follow strict infection‑control protocols and use hospital‑grade products to create safe, comfortable environments. We work closely with facility managers to coordinate schedules, ensuring minimal disruption to daily routines.</p>
        <div className="health-grid">
          <article>
            <h3>Aged Care Facilities</h3>
            <p>Compassionate cleaning services for nursing homes and retirement villages, including resident rooms, dining areas and recreational spaces.</p>
          </article>
          <article>
            <h3>Hospitals &amp; Clinics</h3>
            <p>Detailed cleaning of wards, theatres, waiting rooms and consultation suites to help prevent infection and cross‑contamination.</p>
          </article>
          <article>
            <h3>Medical Offices &amp; Laboratories</h3>
            <p>Sanitisation of equipment, treatment rooms and research spaces, adhering to strict hygiene and confidentiality requirements.</p>
          </article>
          <article>
            <h3>Mental Health &amp; Rehabilitation</h3>
            <p>Discreet, sensitive cleaning services for specialised care facilities that prioritise comfort and dignity.</p>
          </article>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Compassionate Cleaning</h2>
        <p>We understand that cleanliness is integral to wellbeing. Let our experienced team support the health and comfort of your residents and patients.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default AgedCareHealthcare
